import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38ac0e19"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=38ac0e19&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ac0e19')) {
      api.createRecord('38ac0e19', component.options)
    } else {
      api.reload('38ac0e19', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=38ac0e19", function () {
      api.rerender('38ac0e19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadFiles/index.vue"
export default component.exports